import { useState, useCallback } from 'react'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../config/firebase'
import { useAuth } from '../context/AuthContext'

const askAssistantFn = httpsCallable(functions, 'askAssistant')

export function useAiAssistant() {
  const { user, isPremium } = useAuth()
  const [messages, setMessages] = useState([])
  const [loading, setLoading] = useState(false)
  const [remaining, setRemaining] = useState(null)
  const [error, setError] = useState(null)

  const sendMessage = useCallback(async (question, lessonContext) => {
    if (!user || !question.trim()) return

    const userMsg = { role: 'user', content: question.trim() }
    setMessages(prev => [...prev, userMsg])
    setLoading(true)
    setError(null)

    try {
      const result = await askAssistantFn({
        question: question.trim(),
        lessonContext,
        conversationHistory: messages
      })

      const data = result.data
      if (data.error === 'rate_limit_exceeded') {
        setRemaining(0)
        setError('daily_limit')
        return
      }

      setMessages(prev => [...prev, { role: 'assistant', content: data.answer }])
      setRemaining(data.remaining)
    } catch (err) {
      setError(err.message || 'Something went wrong')
    } finally {
      setLoading(false)
    }
  }, [user, messages])

  const resetConversation = useCallback(() => {
    setMessages([])
    setError(null)
  }, [])

  return {
    messages,
    loading,
    remaining,
    error,
    sendMessage,
    resetConversation,
    isLoggedIn: !!user,
    isPremium
  }
}
